import { format, isValid } from 'date-fns'

// Formats a date safely, returning `invalidFallback` (default '-') instead of
// throwing or rendering "Invalid Date" when the input can't be parsed.
export function safeFormatDate<F = string>(
  value: string | Date,
  fmt: string = 'MMM dd, yyyy',
  invalidFallback: F = '-' as unknown as F
): string | F {
  const d = typeof value === 'string' ? new Date(value) : value
  return isValid(d) ? format(d, fmt) : invalidFallback
}
